import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import * as Constants from "../../../common/Constants";
import { Form, Input, Checkbox } from "antd";
import PositionType, {
  IPositionType
} from "../../../model/position/PositionType";

export interface State {}

export interface UpdatePositionTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IPositionType;
}

class UpdatePositionTypeForm extends React.Component<
  UpdatePositionTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updatePositionTypeData;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updatePositionTypeData = PositionType(values);
          updatePositionTypeData.id = rowData.id;
        }
      });
      return updatePositionTypeData;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <Form>
        <Form.Item label={translate("position_type_form.name")}>
          {getFieldDecorator(Constants.PositionTypeInsertForm.Fields.NAME, {
            initialValue: rowData && rowData.name,
            rules: [
              {
                required: true,
                message: translate("position_type_form.required_messages", {
                  field: translate("position_type_form.name")
                })
              }
            ]
          })(<Input />)}
        </Form.Item>
        <Form.Item label={translate("position_type_form.valid")}>
          {getFieldDecorator(Constants.PositionTypeInsertForm.Fields.VALID, {
            valuePropName: "checked",
            initialValue: rowData ? rowData.valid : true
          })(<Checkbox />)}
        </Form.Item>
      </Form>
    );
  }
}

export default UpdatePositionTypeForm;
